import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';

interface FooterProps {
  className?: string;
}

export function Footer({ className = '' }: FooterProps) {
  return (
    <footer className={`bg-gray-900 text-gray-300 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-white mb-4">
              <Trophy className="w-8 h-8" style={{ color: 'var(--color-secondary)' }} />
              <span className="text-xl font-bold">Podium HQ</span>
            </Link>
            <p className="text-gray-400 max-w-md">
              The all-in-one platform for hosting sports events and managing teams.
              From event creation to team rosters, we've got you covered.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tournaments" className="hover:text-white transition-colors">
                  Browse Events
                </Link>
              </li>
              <li>
                <Link to="/for-teams" className="hover:text-white transition-colors">
                  Team management
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/supported-sports" className="hover:text-white transition-colors">
                  Supported Sports
                </Link>
              </li>
              <li>
                <Link to="/setup-live" className="hover:text-white transition-colors">
                  Set up Live
                </Link>
              </li>
              <li>
                <Link to="/stripe-payments" className="hover:text-white transition-colors">
                  Stripe Payments
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help" className="hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/tutorials" className="hover:text-white transition-colors">
                  Tutorials &amp; Webinars
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Podium HQ. All rights reserved.</p>
          <Link 
            to="/site-admin" 
            className="text-gray-600 hover:text-gray-400 transition-colors text-xs"
          >
            Site Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
